import CopyIcon from '@mui/icons-material/FileCopy';
import { IconButton, Link, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { createStyles, makeStyles } from '@mui/styles';
import { getUserProfile } from 'lib/api/users';
import EnhancedBox from 'lib/designSystem/BigBox';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import { copyToClipboard } from 'lib/functions/utils';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

import VersionDisplay from './components/versionDisplay';
import Notifications from './Notifications';

const useStyles = makeStyles(() =>
  createStyles({
    avatarSection: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    avatar: {
      width: '180px !important',
      height: '180px !important',
    },
    userInfoSection: {
      padding: '32px',
      textAlign: 'center',
    },
    pairSection: {
      padding: '10px',
    },
  }),
);

const UserProfile = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const auth = useSelector((state: RootState) => state.auth);
  const { data, isPending } = getUserProfile(dispatch, auth.user?.id);

  if (isPending) return <CenteredCircularProgress />;

  return (
    <div style={{ height: '100%', position: 'relative' }}>
      <VersionDisplay sx={{ position: 'absolute', bottom: 8, right: '58%' }} />
      <HeaderWithActions buttons={[]} title="Mi cuenta" />
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <EnhancedBox>
            <div className={classes.avatarSection}>
              <Avatar className={classes.avatar} />
            </div>
            <div className={classes.userInfoSection}>
              <div className={classes.pairSection}>
                <Typography>
                  <b>Nombre</b>
                </Typography>
                <Typography>{data?.name}</Typography>
              </div>
              <div className={classes.pairSection}>
                <Typography>
                  <b>Email</b>
                </Typography>
                <Typography>{data?.email}</Typography>
              </div>
            </div>
          </EnhancedBox>
          <EnhancedBox margin="16px 0px">
            <Stack direction="column" spacing={2}>
              {data?.enrollmentLink && (
                <Stack direction="column" spacing={1}>
                  <Typography variant="body2">
                    <b>Link de enrolamiento: </b>
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                      onClick={() =>
                        void copyToClipboard(data?.enrollmentLink ?? '')
                      }
                      size="small"
                      aria-label="copy"
                    >
                      <CopyIcon fontSize="small" />
                    </IconButton>
                    <Link
                      href={data?.enrollmentLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                      color="text.secondary"
                    >
                      <Typography component="span" color="text.secondary">
                        {data?.enrollmentLink?.slice(0, 45)}
                        ...
                      </Typography>
                    </Link>
                  </Stack>
                </Stack>
              )}
              {data?.pruffConnectLink && (
                <Stack direction="column" spacing={1}>
                  <Typography variant="body2">
                    <b>Link Pruff Connect: </b>
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                      onClick={() =>
                        void copyToClipboard(data?.pruffConnectLink ?? '')
                      }
                      size="small"
                      aria-label="copy"
                    >
                      <CopyIcon fontSize="small" />
                    </IconButton>
                    <Link
                      href={data.pruffConnectLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                      color="text.secondary"
                    >
                      <Typography component="span" color="text.secondary">
                        {data?.pruffConnectLink ?? '—'}
                      </Typography>
                    </Link>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </EnhancedBox>
        </Grid>
        <Grid item xs={8}>
          <Notifications />
        </Grid>
      </Grid>
    </div>
  );
};

export default UserProfile;
